import { render, staticRenderFns } from "./ScenkonstOtPerformance.vue?vue&type=template&id=4306b338&"
import script from "./ScenkonstOtPerformance.vue?vue&type=script&lang=ts&"
export * from "./ScenkonstOtPerformance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports